<!-- src/components/RunsPanel.svelte -->
<script>
  import { agentStore } from '$lib/stores'

  export let fullView = false

  $: runs = fullView ? $agentStore.runs : $agentStore.runs.slice(0, 8)

  function formatDate(dateStr) {
    return new Date(dateStr).toLocaleString()
  }

  function statusColor(status) {
    const colors = {
      running: '#4ade80',
      pending: '#fbbf24',
      completed: '#60a5fa',
      failed: '#ef4444',
      outsourced: '#a78bfa',
    }
    return colors[status] || '#555570'
  }
</script>

<div class="runs-panel glass-panel">
  <div class="panel-header">
    <h3 class="panel-title">Agent Runs</h3>
    {#if !fullView}
      <button class="btn-view-all">View All →</button>
    {/if}
  </div>

  {#if runs.length === 0}
    <div class="empty-state">
      <div class="empty-icon">⚡</div>
      <p>No agent runs yet</p>
      <span>Create a run to get started</span>
    </div>
  {:else}
    <div class="runs-list">
      <div class="run-header">
        <span class="col-status">Status</span>
        <span class="col-group">Group</span>
        <span class="col-type">Type</span>
        <span class="col-provider">Provider</span>
        <span class="col-tokens">Tokens</span>
        <span class="col-time">Time</span>
      </div>
      {#each runs as run}
        <div class="run-row">
          <span class="col-status">
            <span class="status-dot" style="background: {statusColor(run.status)}"></span>
            {run.status}
          </span>
          <span class="col-group">{run.group_id}</span>
          <span class="col-type">{run.agent_type}</span>
          <span class="col-provider">{run.provider || '—'}</span>
          <span class="col-tokens">{run.tokens_used || 0}</span>
          <span class="col-time">{formatDate(run.created_at)}</span>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .runs-panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .panel-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
  }

  .btn-view-all {
    background: transparent;
    border: 1px solid var(--glass-border);
    color: var(--accent-primary);
    padding: 6px 12px;
    border-radius: var(--radius-sm);
    font-size: 12px;
    cursor: pointer;
    transition: all var(--transition-fast);
  }

  .btn-view-all:hover {
    background: rgba(124, 92, 255, 0.1);
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 48px 24px;
    gap: 8px;
  }

  .empty-icon {
    font-size: 48px;
    opacity: 0.5;
    margin-bottom: 8px;
  }

  .empty-state p {
    color: var(--text-secondary);
    font-size: 16px;
  }

  .empty-state span {
    color: var(--text-muted);
    font-size: 13px;
  }

  .runs-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .run-header, .run-row {
    display: grid;
    grid-template-columns: 100px 1fr 1fr 1fr 80px 160px;
    gap: 12px;
    padding: 10px 12px;
    align-items: center;
    font-size: 13px;
  }

  .run-header {
    font-size: 11px;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid var(--glass-border);
    padding-bottom: 8px;
  }

  .run-row {
    border-radius: var(--radius-sm);
    transition: background var(--transition-fast);
  }

  .run-row:hover {
    background: var(--glass-bg);
  }

  .col-status {
    display: flex;
    align-items: center;
    gap: 6px;
    color: var(--text-secondary);
  }

  .col-group {
    text-transform: capitalize;
    color: var(--text-primary);
  }

  .col-type {
    color: var(--text-secondary);
  }

  .col-provider {
    color: var(--text-secondary);
    font-family: 'SF Mono', 'Monaco', monospace;
    font-size: 12px;
  }

  .col-tokens {
    color: var(--text-muted);
    font-variant-numeric: tabular-nums;
  }

  .col-time {
    color: var(--text-muted);
    font-size: 12px;
  }
</style>